<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="result.length > 0">
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <tr>
                                <th width="25%">Title</th>
                                <th width="15%">Provider</th>
                                <th width="10%">Date</th>
                                <th width="20%">Patient</th>
                                <th width="15%">Created</th>
                                <th width="15%">Updated</th>
                            </tr>
                        </b-thead>

                        <tbody>
                            <tr :key="item.id" v-for="item in result">
                                <td>
                                    <a :href="getSoapURI(item)">{{
                                        item.title
                                    }}</a>
                                </td>
                                <td>{{ item.provider }}</td>
                                <td>{{ item.soap_date }}</td>
                                <td>{{ item.patient_name }}</td>
                                <td>{{ item.created_at }}</td>
                                <td>{{ item.updated_at }}</td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import Report from "@/mixins/report.js";
export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: moment(),
                    end: moment()
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            result: [],
            code: "",
            params: "",
            title: "In Process Medical Notes"
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = true;
        self.data.isShowProvider = true;
        self.data.isShowDateRange = true;
        self.data.reportId = parseInt(self.$route.params.id);
        this._getSetting().then(() => {
            self.data.start = moment().tz(this._timeZone).startOf("month");
            self.data.end = moment().tz(this._timeZone).endOf("month");
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("in_process_medical_notes:refresh", function () {
            self.init();
        });
    },
    beforeDestroy: function () {
        this.data.isShowProvider = false;
        this.data.reportId = null;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            let self = this;
            self.loaded = false;

            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.start = params.start;
                this.data.end = params.end;
            }

            return this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "/report/reports/" +
                        self.$route.params.id,
                    {
                        params: {
                            from: params ? params.from : null,
                            to: params ? params.to : null,
                            provider: params
                                ? params.provider.map(id => id.value)
                                : self.data.provider
                                ? self.data.provider.map(id => id.value)
                                : ""
                        }
                    }
                )
                .then(function (response) {
                    self.meta = response.data.response.resource.meta;
                    self.result = response.data.response.resource.results;
                    self.locale = self.meta.locale.replace("_", "-");
                    self.code = response.status;
                    self.title = self.capitalize(self.meta.title);
                    self.dynamicPageTitle(self.title);
                    if (self.code === 200) {
                        self.loaded = true;
                    }
                });
        },
        getSoapURI(data) {
            return process.env.CI_APPS + "soap/soap/view/" + data.id + "/0";
        }
    }
};
</script>
